import React from 'react';

const FormSkeleton: React.FC<{ rows?: number }> = ({ rows = 2 }) => {
  return (
    <div className="animate-pulse w-full">
      {[...Array(rows)].map((_, i) => (
        <div key={i} className="mb-4 mt-4">
          <div className="h-10 bg-slate-100 rounded w-full" />
        </div>
      ))}
    </div>
  );
};

export default FormSkeleton;

